/** @deprecated */
export var ConditionalBlockFiltersEngine;
(function (ConditionalBlockFiltersEngine) {
    ConditionalBlockFiltersEngine["ROCKETCHAT"] = "rocket.chat";
    ConditionalBlockFiltersEngine["LIVECHAT"] = "livechat";
})(ConditionalBlockFiltersEngine || (ConditionalBlockFiltersEngine = {}));
//# sourceMappingURL=ConditionalBlockFiltersEngine.js.map